import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import { Table, Empty, Col, Row } from "antd";
import { OrderedListOutlined, RollbackOutlined } from "@ant-design/icons";
import { ColumnHelper } from "../../util/TableHelper";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import StockPriceHistoryByStockListFilter from "../Filters/StockPriceHistoryByStockListFilter";

const StockPriceHistoryByStockList = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "ÜRÜN FİYAT DEĞİŞİKLİKLERİ",
  });
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(
    () => getTableData(),
    [props.match.params.stockId, tableDataQueryOptions]
  );

  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }

    RequestHandler.get(
      `/StockPriceHistory/GetListByStockId/${props.match.params.stockId}?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response,
        total: response.length,
        loading: false,
      });
    });
  };

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "Ürün Adı",
      dataIndex: "stockName",
      key: "stockName",
      align: "left",
    },
    {
      title: "Hareket Tarihi",
      dataIndex: "addDateString",
      key: "addDateString",
      align: "left",
    },

    {
      title: "Eski Vergisiz Alış Fiyatı",
      dataIndex: "oldPurchasePriceExcTaxesString",
      key: "oldPurchasePriceExcTaxesString",
      align: "left",
    },
    {
      title: "Yeni Vergisiz Alış Fiyatı",
      dataIndex: "newPurchasePriceExcTaxesString",
      key: "newPurchasePriceExcTaxesString",
      align: "left",
    },
    {
      title: "Eski Vergiler Dahil Alış Fiyatı",
      dataIndex: "oldPurchasePriceIncTaxesString",
      key: "oldPurchasePriceIncTaxesString",
      align: "left",
    },
    {
      title: "Yeni Vergiler Dahil Alış Fiyatı",
      dataIndex: "newPurchasePriceIncTaxesString",
      key: "newPurchasePriceIncTaxesString",
      align: "left",
    },
    // {
    //   title: "Eski Vergisiz Satış Fiyatı",
    //   dataIndex: "oldSellingPriceExcTaxesString",
    //   key: "oldSellingPriceExcTaxesString",
    //   align: "left",
    // },
    // {
    //   title: "Yeni Vergisiz Satış Fiyatı",
    //   dataIndex: "newSellingPriceExcTaxesString",
    //   key: "newSellingPriceExcTaxesString",
    //   align: "left",
    // },
    // {
    //   title: "Eski Vergiler Dahil Satış Fiyatı",
    //   dataIndex: "oldSellingPriceIncTaxesString",
    //   key: "oldSellingPriceIncTaxesString",
    //   align: "left",
    // },
    // {
    //   title: "Yeni Vergiler Dahil Satış Fiyatı",
    //   dataIndex: "newSellingPriceIncTaxesString",
    //   key: "newSellingPriceIncTaxesString",
    //   align: "left",
    // },
    {
      title: "Alış Fiyatı Yüzdelik Değişimi",
      dataIndex: "purchasePriceChangeRate",
      key: "purchasePriceChangeRate",
      align: "left",
      render: (text) =>
        text.toString().includes("-") ? (
          <div style={{ color: "red" }}>{renderDecimal(text)} %</div>
        ) : (
          <div style={{ color: "green" }}>{renderDecimal(text)} %</div>
        ),
    },
    // {
    //   title: "Satış Fiyatı Yüzdelik Değişimi",
    //   dataIndex: "sellingPriceChangeRate",
    //   key: "sellingPriceChangeRate",
    //   align: "left",
    //   render: (text) =>
    //     text.toString().includes("-") ? (
    //       <div style={{ color: "red" }}>{renderDecimal(text)} %</div>
    //     ) : (
    //       <div style={{ color: "green" }}>{renderDecimal(text)} %</div>
    //     ),
    // },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  return (
    <>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={() => history.goBack()}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> GERİ DÖN
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
      </Row>
      <StockPriceHistoryByStockListFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        isUseStockId={false}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: tableData.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
    </>
  );
};

export default StockPriceHistoryByStockList;
